import { IN_FLIGHT_UPLOAD_STATUSES } from "@/common/constants/autoDj"

export const autoDj = (state) => {
  return state.autoDj
}

export const previewURL = (state) => {
  return state.previewURL
}

export const autoDjPlaylist = (state) => {
  return state.autoDj.playlist
}

export const tracksCount = (state) => {
  return state.autoDj.playlist.length
}

export const tracksLimit = (state, getters, rootState, rootGetters) => {
  const limit = rootGetters["Subscription/allowedTracksCount"]

  if (limit === null || limit === undefined || limit === "") {
    return null
  }

  const parsed = Number(limit)

  return Number.isFinite(parsed) ? parsed : null
}

export const isTracksLimitKnown = (state, getters) => {
  return getters.tracksLimit !== null
}

export const isTracksLimitLoading = (state, getters, rootState, rootGetters) => {
  return !getters.isTracksLimitKnown && !rootGetters["Subscription/accountPlanFeatures"]
}

export const uploadingTracksCount = (state, getters, rootState, rootGetters) => {
  const uploadQueue = rootGetters["Library/uploadQueue"]

  return uploadQueue.filter(
    (media) => media.stationKey === state.stationKey && IN_FLIGHT_UPLOAD_STATUSES.includes(media.status)
  ).length
}

export const allowedToUploadCount = (state, getters) => {
  if (!getters.isTracksLimitKnown) {
    return 0
  }

  return Math.max(getters.tracksLimit - getters.tracksCount - getters.uploadingTracksCount, 0)
}

export const isTracksLimitReached = (state, getters) => {
  return getters.isTracksLimitKnown && getters.tracksCount >= getters.tracksLimit
}

export const uploadAllowanceStatus = (state, getters) => {
  if (getters.isTracksLimitLoading) {
    return { code: "unknown" }
  }

  if (!getters.isTracksLimitKnown) {
    return { code: "unavailable" }
  }

  if (getters.isTracksLimitReached) {
    return { code: "reached", count: getters.tracksLimit }
  }

  if (!getters.allowedToUploadCount) {
    return { code: "queued" }
  }

  return { code: "remaining", count: getters.allowedToUploadCount }
}

export const current = (state) => {
  return state.current
}
